import { Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { Add, Delete, Folder, Close } from '@mui/icons-material';
import React, { useState } from 'react';

const FuncionesOrganismo = ({ data, setDatos }) => {
    const actividades = data.actividades || [];

    const handleAddActividad = () => {
        setDatos({
            target: {
                name: 'actividades',
                value: [
                    ...actividades,
                    {
                        nombre: '',
                        n_empresas: '',
                        n_socios: '',
                        // imagenes: [],
                    }
                ]
            }
        });
    };

    const handleRemoveActividad = (index) => {
        const updatedActividades = data.actividades.filter((_, i) => i !== index);
        setDatos({
            target: {
                name: 'actividades',
                value: updatedActividades
            }
        });
    };

    const handleInputChange = (e, index, field) => {
        const updatedActividades = [...data.actividades];
        updatedActividades[index][field] = e.target.value;
        setDatos({
            target: {
                name: 'actividades',
                value: updatedActividades
            }
        });
    };

    const handleImageUpload = (e, index) => {
        const image = e.target.files[0];
        if (image) {
            const reader = new FileReader();
            reader.onload = (event) => {
                // const updatedActividades = [...data.actividades];
                // if (updatedActividades[index].imagenes.length < 2) {
                // updatedActividades[index].imagenes.push({
                image.dataurl = event.target.result;
                image.index = index;
                const updatedActividades = [...data.imagenes];
                updatedActividades.push(image);
                setDatos({
                    target: {
                        name: 'imagenes',
                        value: updatedActividades
                    }
                });
            };
            reader.readAsDataURL(image);
        }
    };

    const handleRemoveImage = (indexActividad, imageUrl) => {
        let updatedImages = [...data.imagenes];
        // updatedActividades[indexActividad].imagenes = updatedActividades[indexActividad].imagenes.filter(img => img.dataurl !== imageUrl);
        let imgIndex = updatedImages.filter((i) => i.index == indexActividad).filter(img => img.dataurl !== imageUrl);
        updatedImages = [...updatedImages.filter((i) => i.index != indexActividad), ...imgIndex];
        setDatos({
            target: {
                name: 'imagenes',
                value: updatedImages
            }
        });
    };

    return (
        <div>
            <Typography variant="h5" sx={{ my: 2 }}>Funciones y Servicios</Typography>
            {data.actividades.map((actividad, index) => (
                <Box key={index} sx={{ mb: 4, p: 2, border: 1, borderColor: '#e0dcda', borderRadius: 2 }}>
                    <Typography variant="h6">Actividad o Proceso {index + 1}</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Descripción de la actividad o proceso"
                        value={actividad.nombre}
                        inputProps={{ maxLength: 100 }}
                        onChange={(e) => handleInputChange(e, index, 'nombre')}
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            fullWidth
                            label="# de empresas y/u organizaciones atendidas"
                            type="number"
                            value={actividad.n_empresas}
                            onChange={(e) => handleInputChange(e, index, 'n_empresas')}
                        />
                        <TextField
                            fullWidth
                            label="# socios atendidos"
                            type="number"
                            value={actividad.n_socios}
                            onChange={(e) => handleInputChange(e, index, 'n_socios')}
                        />
                    </Stack>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h6">Fotogalería de la actividad o proceso {index + 1} (máximo 2 fotos)</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            {data.imagenes.filter((i) => i.index == index).map((image) => (
                                <Box key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1 }}>
                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => handleRemoveImage(index, image.dataurl)}>
                                        <Close />
                                    </IconButton>
                                    <img src={image.dataurl ?? image} alt={image.name} width="150px" />
                                </Box>
                            ))}
                        </Box>
                        <Button
                            disabled={data.imagenes.filter((i) => i.index == index).length >= 2}
                            component="label"
                            variant="contained"
                            startIcon={<Folder />}
                        >
                            Agregar Imagen
                            <input type="file" accept="image/*" hidden onChange={(e) => handleImageUpload(e, index)} />
                        </Button>
                    </Box>
                    <Button sx={{ mt: 2 }} startIcon={<Delete />} color="error" onClick={() => handleRemoveActividad(index)}>
                        Eliminar Actividad
                    </Button>
                </Box>
            ))}
            <Button variant="contained" color="primary" onClick={handleAddActividad} startIcon={<Add />}>
                Agregar Actividad
            </Button>
        </div>
    );
};

export default FuncionesOrganismo;
